import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { DataSyncProgress } from "../../../../_services/offline-data-sync.service";
import { DATA_SYNC_STEP } from "../../../electron.constants";

@Injectable({
  providedIn: 'root'
})
export class ProgressDialogService {
  private totalDataCountSubject: Subject<DataSyncProgress> = new Subject<DataSyncProgress>();
  public totalDataCount$ = this.totalDataCountSubject.asObservable();

  private uploadedProgressStepSubject: Subject<DATA_SYNC_STEP> = new Subject<DATA_SYNC_STEP>();
  public uploadedProgressStep$ = this.uploadedProgressStepSubject.asObservable();

  public updateTotalDataCount(dataCount: DataSyncProgress) {
    this.totalDataCountSubject.next(dataCount);
  }

  public updateProgressStep(dataSyncStep: DATA_SYNC_STEP) {
    this.uploadedProgressStepSubject.next(dataSyncStep);
  }

}
